export default __webpack_public_path__ + "static/SR USA - Safety Data Sheet (SDS) - Caramel Color (Liquid)-e0a6a291e274bc993993e44d0c3d13e8.pdf";